import React, { useEffect, useState } from "react";
import { CalendarOutlined } from "@ant-design/icons";
import { Button, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { ReactComponent as MinimiseIcon } from "../../../assests/minimise-icon.svg";
import { ReactComponent as ChatWhiteIcon } from "../../../assests/chat-white-icon.svg";

import ChatMsgPad from "../../common/chat-communication/ChatMsgPad";
import ChatTerms from "../../common/chat-terms/ChatTerms";

import {
  setAllowChat,
  setIsbuyerChatHistory,
} from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";

import { getChatHistory } from "../../../store/thunks/common-thunks/commonThunk";

import { markProductAsRead } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";

import { clearLiveMsgNotificationForProduct } from "../../../store/slices/common-slice/web-sockets/WebSocketMsgSlice";
import { formatDate } from "date-fns";
import { formatDateWithTimestamp, formatToMMDDYYYY } from "../utils/Utils";

const NegotiationChat = ({
  isChat,
  selectedChatProduct,
  setIsChat,
  chatInitialTime,
  updateSelectedChatProduct,
}) => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const { userId } = useSelector((state) => state.login);
  const { allowChat } = useSelector(
    (state) => state.chatCommunicationHandleSlice,
  );
  const { chatsMonitered, professionalGuidelines } = useSelector(
    (state) => state.userprofile,
  );
  const { buyerProductsChatHistory } = useSelector(
    (state) => state.chatHistory,
  );
  const { isLiveMsgNotification = [] } = useSelector(
    (state) => state.webSocketMsgs,
  );
  const product = selectedChatProduct?.originalProduct;
  const bookingId = product?.id;
  const productId = product?.product_id;
  const campaignId = product?.campaign_id;
  const receiverUserId = product?.client_mongo_id;
  const [optimisticTermsMessage, setOptimisticTermsMessage] = useState(null);
  useEffect(() => {
    if (chatsMonitered === true && professionalGuidelines === true) {
      dispatch(setAllowChat(true));
    } else {
      dispatch(setAllowChat(false));
    }
  }, [chatsMonitered, professionalGuidelines, dispatch]);
  useEffect(() => {
    if (!isChat || !campaignId || !bookingId) {
      return;
    }

    dispatch(
      getChatHistory({
        campaignId: String(campaignId),
        bookingId: String(bookingId),
      }),
    );
  }, [isChat, campaignId, bookingId, dispatch]);

  useEffect(() => {
    if (!buyerProductsChatHistory?.length || !productId || !bookingId) {
      return;
    }
    const chatHistory = buyerProductsChatHistory.find(
      (item) =>
        String(item?.productId) === String(productId) &&
        String(item?.bookingId) === String(bookingId),
    );

    dispatch(setIsbuyerChatHistory(chatHistory ? { ...chatHistory } : null));
  }, [buyerProductsChatHistory, productId, bookingId, dispatch]);
  useEffect(() => {
    if (
      !isChat ||
      !campaignId ||
      !bookingId ||
      !isLiveMsgNotification?.length
    ) {
      return;
    }

    const campaignIdString = String(campaignId);
    const bookingIdString = String(bookingId);

    const hasActiveLiveMsg = isLiveMsgNotification.some(
      (msg) =>
        String(msg?.campaignId) === campaignIdString &&
        String(msg?.bookingId) === bookingIdString,
    );

    if (!hasActiveLiveMsg) {
      return;
    }

    // Mark as read
    dispatch(
      markProductAsRead({
        campaignId: campaignIdString,
        productId: bookingIdString,
        readAt: Date.now(),
      }),
    );

    // Clear notification
    dispatch(
      clearLiveMsgNotificationForProduct({
        campaignId: campaignIdString,
        productId: bookingIdString,
      }),
    );
  }, [isLiveMsgNotification, isChat, campaignId, bookingId, dispatch]);
  const handleCloseChat = () => {
    setIsChat(false);
  };
  const formatProductPeriod = (fromDate, toDate) => {
    const getDate = (value) => {
      if (!value) return null;
      if (value?.$date?.$numberLong) {
        return new Date(Number(value.$date.$numberLong));
      }
      if (value?.$numberLong) {
        return new Date(Number(value.$numberLong));
      }
      if (typeof value === "object" && value?.date) {
        return new Date(value.date);
      }
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date;
    };

    const start = getDate(fromDate);
    const end = getDate(toDate);

    if (!start && !end) return "-";

    const formatDate = (date) =>
      date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });

    if (start && end) {
      return `${formatDate(start)} – ${formatDate(end)}`;
    }

    return formatDate(start || end);
  };

  return (
    <div
      className={`negotiate-terms-chat-container ${
        isChat ? "negotiate-terms-chat" : ""
      }`}
    >
      <div className="terms-app-chat-red-container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <ChatWhiteIcon
            style={{
              width: "20px",
              height: "20px",
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "80%",
            }}
          >
            <Text className="common-text-FFFFFF-12">
              {selectedChatProduct?.asset || "-"}
            </Text>
            <span className="common-text-ffffffb2-12">Negotiation</span>
          </div>
        </div>
        <MinimiseIcon
          className="minimise-chat-icon"
          onClick={handleCloseChat}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="chat-date-price-conatiner">
          <Text className="location-grey-text-12">
            {selectedChatProduct?.cost || 0}
          </Text>

          <div
            style={{
              display: "flex",
              gap: "5px",
            }}
          >
            <CalendarOutlined
              style={{
                width: "12px",
                height: "auto",
                color: "#98a4b5",
                marginLeft: "5px",
              }}
            />

            <Text className="location-grey-text-12">
              {selectedChatProduct?.originalProduct?.booked_from &&
              selectedChatProduct?.originalProduct?.booked_to
                ? `${formatProductPeriod(selectedChatProduct.originalProduct.booked_from)} - ${formatProductPeriod(selectedChatProduct.originalProduct.booked_to)}`
                : "-"}
            </Text>
          </div>
        </div>

        <div style={{ margin: "10px" }}>
          <div className="negotiation-chat-body">
            {allowChat ? (
              <>
                <ChatMsgPad
                  key={`${campaignId}-${bookingId}-${productId}`}
                  bookingId={bookingId}
                  productId={productId}
                  campaignId={campaignId}
                  currentUserId={userId}
                  receiverUserId={receiverUserId}
                  selectedChatProduct={selectedChatProduct}
                  optimisticTermsMessage={optimisticTermsMessage}
                  updateSelectedChatProduct={updateSelectedChatProduct}
                />
              </>
            ) : (
              <>
                <ChatTerms />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NegotiationChat;
